import { Selector, State, StateContext } from '@ngxs/store';
import { Receiver, EmitterAction } from '@ngxs-labs/emitter';
import { Injectable, Injector } from '@angular/core';
import { MobileConfigurationDto, SideMenuConfigurationDto } from '../@models';
import { MobileConfigurationService } from '../@services';

export interface MobileConfigurationStateModel {
  configuration: MobileConfigurationDto | null;
  loading: boolean;
}

@State<MobileConfigurationStateModel>({
  name: 'mobileConfiguration',
  defaults: {
    configuration: null,
    loading: false
  }
})
@Injectable()
export class MobileConfigurationState {
  private static configService: MobileConfigurationService;

  constructor(injector: Injector) {
    MobileConfigurationState.configService = injector.get(MobileConfigurationService);
  }

  @Selector()
  static configuration(state: MobileConfigurationStateModel): MobileConfigurationDto | null {
    return state.configuration;
  }

  @Selector()
  static sideMenuConfiguration(state: MobileConfigurationStateModel): SideMenuConfigurationDto | null {
    return state.configuration?.sideMenuConfiguration || null;
  }

  @Selector()
  static isLoading(state: MobileConfigurationStateModel): boolean {
    return state.loading;
  }

  @Receiver()
  static load({ setState, getState }: StateContext<MobileConfigurationStateModel>) {
    setState({ ...getState(), loading: true });
    this.configService.getMobileConfiguration().subscribe({
      next: (configuration) => {
        setState({ configuration, loading: false });
      },
      error: () => {
        setState({ ...getState(), loading: false });
      }
    });
  }

  @Receiver()
  static clear({ setState }: StateContext<MobileConfigurationStateModel>) {
    setState({ configuration: null, loading: false });
  }
}
